module.exports = __webpack_public_path__ + "img/ton.79354e72.svg";